<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre3"><span id="Page_4" title="[Pg 4]"></span></p>
<h2 class="nobreak" id="Fourth_Day">Fourth Day.</h2>
</div>
<div class="figcenter4" id="i08">
<img alt="" class="w" id="id-3761220976608827055" src="Images/img0004.jpg"/>
</div>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse1">For Heaven’s sake</div>
<div class="verse4">let us</div>
<div class="verse5">examine sacredly</div>
<div class="verse">whether there is any</div>
<div class="verse5">wrong entrusted</div>
<div class="verse">to us to set right.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Little Dorrit.</i></p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">Surprises, like misfortunes,</div>
<div class="verse2">rarely come alone.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Dombey and Son.</i></p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">What the poor are to the poor is little known</div>
<div class="verse1">excepting to themselves and God.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Bleak House.</i></p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">An honest man is one of the few great works</div>
<div class="verse2">that can be seen for nothing.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Martin Chuzzlewit.</i></p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">Thinking begets thinking.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Oliver Twist.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?021c4211